import { createContext, useContext } from 'react';

type PageHeaderOffsetContextType = {
  shouldOffsetHeader: boolean;
  setShouldOffsetHeader: (hideMetaNav: boolean) => void;
  scrollMovementOffset: number;
  setScrollMovementOffset: (scrollMovementOffset: number) => void;
  isFixed: boolean;
  setIsFixed: (isFixedArg: boolean) => void;
};

/**
 * This provides common behavior related to offsetting the Composable Page Header.
 * It gets its values from where the `scrollMovementOffset` and default offset heights
 * are set in the respective renderer's component, which uses the prop in `static/bundles/composable-page-header/components/GlobalPageHeaderContainer.tsx`.
 * Default initial values are applied in `static/bundles/composable-page-header/providers/GlobalPageHeaderStateProvider.tsx`.
 */
const PageHeaderOffsetContext = createContext<PageHeaderOffsetContextType | undefined>(undefined);

export const usePageHeaderOffset = () => {
  const context = useContext(PageHeaderOffsetContext);

  return context;
};

export default PageHeaderOffsetContext;
